import {Component, effect, inject, OnInit, signal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {authStore} from "../../../core/service/auth/auth.store";
import {InputComponent} from "../../form-elements/input/input/input.component";
import {HttpClient} from "@angular/common/http";
import {TranslatePipe} from "@ngx-translate/core";
import {ProjectStore} from "../../store/project.store";
import {LamelareaStore} from "../../product-card/product-card/lamelarea.store";
import {Subscription} from "rxjs";

type QuotationFormData = {
  projectRecordId: string;
  withSave?: boolean;
  projectName?: string;
  projectRecordName?: string;
}

@Component({
  selector: 'app-quotation-form',
  imports: [
    InputComponent,
    ReactiveFormsModule,
    FormsModule,
    TranslatePipe
  ],
  templateUrl: './quotation-form.component.html',
  styleUrl: './quotation-form.component.scss'
})
export class QuotationFormComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<QuotationFormComponent>);
  readonly data: QuotationFormData = inject(MAT_DIALOG_DATA);
  readonly http: HttpClient = inject(HttpClient);

  readonly projectStore = inject(ProjectStore);
  readonly lamellaAreaStore = inject(LamelareaStore);

  readonly user = inject(authStore).loggedInUser();

  readonly isInvalid = signal(false);

  readonly quotationForm = new FormGroup({
    projectName: new FormControl<string>( "" , {validators: [Validators.required]}),
    projectRecordName: new FormControl<string>( "" , {validators: [Validators.required]}),
    projectRecordId: new FormControl<string>( "" ),
    description: new FormControl<string>(""),
    email: new FormControl<string>(this.user?.email ?? "", {validators: [Validators.required,Validators.email]}),
    phone: new FormControl<string>(this.user?.phoneNumber ?? ""),
    companyName: new FormControl<string>(this.user?.companyName ?? ""),
  })

  ngOnInit() {
    this.quotationForm.get('projectRecordId')?.setValue(this.data?.projectRecordId ?? "");
    this.quotationForm.get('projectName')?.setValue(this.data?.projectName ?? this.projectStore?.name() ?? "");
    this.quotationForm.get('projectRecordName')?.setValue(this.data?.projectRecordName ?? this.projectStore?.projectRecord()?.name ?? "");
  }

  onSubmit() {
    if (this.quotationForm.invalid) {
      this.isInvalid.set(true);
      return;
    }

    if (this.data.withSave) {
      const resolver = new Promise<boolean>((resolve) => {
            if (!this.quotationForm.controls.projectRecordId.value) {
              this.handleSave().then((recordId: any) => {
                this.quotationForm.controls.projectRecordId.setValue(recordId);
                this.http.post('/api/quotation', this.quotationForm.value).subscribe(() => resolve(true) )
              })
            } else{
              this.http.post('/api/quotation', this.quotationForm.value).subscribe(() => resolve(true))
            }
      })
      this.dialogRef.close(resolver);
    } else {
      const resolver = new Promise<boolean>((resolve) => this.http.post('/api/quotation', this.quotationForm.value).subscribe(()=>resolve(true)))
      this.dialogRef.close(resolver);
    }

  }

  handleProjectReferenceRemoval() {
    if (confirm("Are you sure you want to remove current configuration from project reference?")) {
      this.projectStore.clearProject();
    }
  }

  handleProjectRecordReferenceRemoval() {
    if (confirm("Are you sure you want to create new project record?")) {
      this.projectStore.clearProjectRecord();
    }
  }

  private async handleSave() {
    return new Promise((resolve) => {

      const project = this.projectStore.provideProject({
        name: this.quotationForm.controls.projectName.value,
        isPublic: false
      });

      const record = this.projectStore.provideProjectRecord(this.quotationForm.controls.projectRecordName.value);
      record.lamellaAreaGroups = this.lamellaAreaStore.getLamellaAreaGroups().map(g => ({...g, id: undefined}));
      project.projectRecords = [record];

      if (this.projectStore?.id()) {
        this.projectStore.saveNewProjectRecord(record).then(() => {
          this.lamellaAreaStore.setPristine();
          resolve(this.projectStore.projectRecord().id)
        });

      } else {
        this.projectStore.saveNewProject(project).then(() => {
          this.lamellaAreaStore.setPristine();
          resolve(this.projectStore.projectRecord().id);
        });

      }
    })
  }
}
